interface IconProps {
  className?: string;
}

const SubscriptionIcon: React.FC<IconProps> = (props) => {
  return (
    <>
      <svg
        className={props.className}
        width="32"
        height="32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path className="fill-current" d="M17 9V6h-2v3h2Z" />
        <mask id="a" fill="#fff">
          <path d="M14 24a2 2 0 1 0 4 0h-4Z" />
        </mask>
        <path
          className="stroke-current"
          d="M14 24a2 2 0 1 0 4 0h-4Z"
          strokeWidth="4"
          mask="url(#a)"
        />
        <path
          className="stroke-current"
          d="M11 15c0 6-3 6-3 6h16s-3 0-3-6v-1a5 5 0 0 0-10 0v1Z"
          strokeWidth="2"
        />
      </svg>
    </>
  );
};

export default SubscriptionIcon;
